<!--
 * @Descripttion: 活动组件
 * @Author: Yang Maoxiang
 * @Date: 2020-08-26 15:15:32
 * @LastEditTime: 2023-11-07 20:23:01
-->
<template>
  <div class="activity" v-if="ActInfo && ActInfo.length">
    <!-- 普通活动 -->
    <v-list-view
      :class="[{ 'activity-new': !OrdinaryAct.length }]"
      name="活动"
      right-icon="arrow-right-v3"
      @click="showPop"
      v-if="OrdinaryAct.length"
    >
      <ul class="right-content">
        <li
          :class="['right-content-item', { 'right-content-list': OrdinaryAct.length > 3 && index >= 2 }]"
          v-for="(item, index) in OrdinaryAct"
          :key="index"
          v-track="[
            {
              act: 'show',
              params: {
                cfrom: '151|003|02|077',
                event_id: '151|003|02|077',
                page_name: 1,
                promotion_name: item.actTitle,
                promotion_type: 1,
                source_type: recycleSupplierId,
                card_type: 1,
                sku_id: skuId
              }
            },
            {
              act: 'click',
              params: {
                cfrom: '151|003|01|077',
                event_id: '151|003|01|077',
                page_name: 1,
                promotion_name: item.actTitle,
                promotion_type: 1,
                source_type: recycleSupplierId,
                card_type: 1,
                sku_id: skuId
              }
            }
          ]"
        >
          <div class="item">
            <div class="item-content">{{ item.actTitle }}</div>
          </div>
          <div
            class="item-desc"
            v-if="(index < 2 || OrdinaryAct.length == 3) && item.actType == 1"
            v-html="ActDesc(1)"
          ></div>
          <div class="item-desc" v-if="(index < 2 || OrdinaryAct.length == 3) && item.actType != 1">
            {{ item.actDesc }}
          </div>
        </li>
      </ul>
    </v-list-view>
    <!-- 特殊活动
      如果有一站式换新，则展示一站式换新
      如果没有一站式换新，则展示推荐位的第一个活动
     -->
    <div
      class="renewal-ld"
      @click="goAct(SpecialAct)"
      tabindex="0"
      v-if="SpecialAct"
      v-track="[
        {
          act: 'show',
          params: {
            cfrom: '151|003|02|077',
            event_id: '151|003|02|077',
            page_name: 1,
            promotion_name: SpecialAct.actTitle,
            promotion_type: 2,
            source_type: recycleSupplierId,
            card_type: showOneStopAct ? 2 : 1,
            sku_id: skuId
          }
        },
        {
          act: 'click',
          params: {
            cfrom: '151|003|01|077',
            event_id: '151|003|01|077',
            page_name: 1,
            promotion_name: SpecialAct.actTitle,
            source_type: recycleSupplierId,
            card_type: showOneStopAct ? 2 : 1,
            promotion_type: 2,
            sku_id: skuId
          }
        }
      ]"
    >
      <!-- 以旧换新新大卡 -->
      <RecycleOneStop :oneStopAct="oneStopAct" v-if="showOneStopAct" />
      <div class="a-ld" v-else>
        <!-- 以旧换新及镭雕特殊icon -->
        <img src="./images/recycle-icon.png" class="a-icon" alt="" v-if="SpecialAct.actType == 1" />
        <img src="./images/laser-g.gif" class="a-icon" alt="" v-if="SpecialAct.actType == 2" />
        <div class="a-info">
          <span
            v-if="SpecialAct.recommendTitleText"
            class="a-title text"
          >{{ SpecialAct.recommendTitleText }}</span>
          <img
            v-else-if="SpecialAct.recommendTitle"
            class="a-title"
            v-lazy="SpecialAct.recommendTitle"
            :alt="SpecialAct.actType == 1 ? '以旧换新' : '免费雕刻机身图文'"
          />
          <div class="a-desc" v-if="SpecialAct.actType == 1" v-html="reNewAct ? ActDesc(1) : SpecialAct.actDesc"></div>
          <div class="a-desc" v-else>{{ SpecialAct.actMemberDesc || SpecialAct.actDesc }}</div>
        </div>
        <div class="a-imgs" v-if="SpecialAct.actType == 2 && SpecialAct.backgroundUrl">
          <img :src="SpecialAct.backgroundUrl" alt="" />
        </div>
        <div class="a-action">
          <v-button size="small" type="frame">{{ SpecialAct.skipDesc }}</v-button>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <v-os-popup
      v-if="ActInfo && ActInfo.length"
      :show="isShow"
      title="活动"
      @close="close"
      :footerShow="false"
      container="body"
    >
      <activity-popup
        :ActInfo="ActInfo"
        :ActDesc="reNewAct ? ActDesc(2) : ''"
        @close="close"
        @goToRenew="checkRenewActivityLink"
      ></activity-popup>
    </v-os-popup>
  </div>
</template>

<script>
import ActivityPopup from '../activity-popup'
import { mapState, mapGetters, mapActions } from 'vuex'
import CONSTANT from './constant'
import { app } from '@/utils'
import RecycleOneStop from './components/recycle-one-stop'

export default {
  name: 'Activity',
  components: {
    ActivityPopup,
    RecycleOneStop
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', [
      'skuId',
      'isGroup',
      'showOneStopRecycle',
      'isLinkOnlyRecycle',
      'isLinkActivity',
      'isSelfModel',
      'recycleSupplierId',
      'tradeInAcShowPrice',
      'renewPriceActivityPopupLabel'
    ]),
    // 活动信息
    ActInfo() {
      let activity = this.skuInfo?.commodityActivities
      if (activity) {
        // 如果是拼购 则过滤掉镭雕活动
        let temp = this.isGroup ? activity.filter(item => item.actType != CONSTANT.LASER_CARVING_ACTIVITY) : activity
        // 如果不露出以旧换新活动，则过滤掉悬浮条或者以旧换新活动
        temp = this.showOneStopRecycle
          ? temp
          : temp.filter(
              item => item.actType != CONSTANT.TRADE_IN_ACTIVITY && item.actType != CONSTANT.ONE_STOP_ACTIVITY
            )
        return temp
      } else {
        return ''
      }
    },
    // 普通活动
    OrdinaryAct() {
      return this.ActInfo.filter(item => item.recommendStatus == CONSTANT.ORDINARY_ACTIVITY_TYPE && item.actType != 6)
    },
    // 特殊活动 只会展示数组的第一个
    SpecialAct() {
      let r = this.ActInfo.filter(item => item.recommendStatus == CONSTANT.SPECIAL_ACTIVITY_TYPE)[0]
      return r
    },
    // 以旧换新活动 只会展示数组的第一个
    reNewAct() {
      return this.ActInfo.filter(item => item.actType == CONSTANT.TRADE_IN_ACTIVITY)[0]
    },
    // 一站式换新活动
    oneStopAct() {
      return this.skuInfo?.recycleOneStopActivity
    },
    // 有一站式换新数据 并且 SpecialAct.actType = 1  展示新大卡
    // SpecialAct.actType = 1 并且没有一站式换新数据 展示旧大卡
    showOneStopAct() {
      const { SpecialAct, isLinkOnlyRecycle, isLinkActivity, isSelfModel } = this
      if (isLinkOnlyRecycle || isLinkActivity) return false
      // 如果特殊活动是以旧换新活动，且存在估价数据
      if (SpecialAct.actType == 1 && isSelfModel) return true
      return false
    }
  },
  mounted() {},
  methods: {
    ...mapActions('detailv3', ['showSkuSelect', 'savePreFocusElByEvent', 'setRecycleIframeParams']),
    showPop(e) {
      this.isShow = true
      this.savePreFocusElByEvent(e)
    },
    /**
     * @description: 镭雕活动处理
     * @Author: Yang Maoxiang
     * @Date: 2020-09-10 14:33:50
     */
    goAct(SpecialAct) {
      const { actType, skipLink } = SpecialAct
      const { LASER_CARVING_ACTIVITY, TRADE_IN_ACTIVITY, ONE_STOP_ACTIVITY } = CONSTANT
      if (actType == LASER_CARVING_ACTIVITY) {
        this.showSkuSelect({
          isShow: true,
          params: {
            source: 9,
            isShow: true,
            checked: {
              laser: true
            }
          }
        })
      } else if (actType == TRADE_IN_ACTIVITY) {
        this.checkRenewActivityLink({ trackFrom: 1 }, skipLink) // 商详页大卡
      } else if (actType == ONE_STOP_ACTIVITY) {
        this.goToRenew({ trackFrom: 2 }) // 商详页悬浮条
      } else if (skipLink) this.jump(skipLink)
    },
    checkRenewActivityLink(params, skipLink) {
      const onlyRecycleLink = `${this.linkBase}/recycle/phones/index`
      if (this.isLinkOnlyRecycle) {
        this.jump(onlyRecycleLink)
        return
      }
      if (this.isLinkActivity) {
        this.jump(skipLink)
        return
      }
      this.goToRenew(params)
    },
    jump(skipLink) {
      if (!skipLink) return
      app.openNewWebview({
        url: skipLink
      })
    },
    goToRenew(params) {
      this.$emit('goToRenew', params)
    },
    /**
     * @description: 以旧换新描述
     * @Author: Yang Maoxiang
     * @Date: 2020-10-12 10:57:18
     */
    ActDesc(state) {
      if (state == 1 && this.tradeInAcShowPrice && this.renewPriceActivityPopupLabel) {
        return this.renewPriceActivityPopupLabel
      }
      if (this.reNewAct?.recyclePrice) {
        let str = ''
        if (state == '1') {
          str = this.reNewAct.actDesc
        } else if (state == '2') {
          str = this.reNewAct.recommendDesc
        }
        return str.replace('%c', `<span style="color: #f10313;">${this.reNewAct.recyclePrice}</span>`)
      } else {
        return this.reNewAct.actDesc
      }
    },
    /**
     * @description: 关闭弹窗
     * @Author: Yang Maoxiang
     * @Date: 2020-08-25 11:14:44
     */
    close() {
      this.isShow = !this.isShow
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .right-content-item .item-desc {
    height: 60px;
  }
}
</style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
